// ThemeContext.js
import React, { createContext, useState } from 'react';

const ThemeContext = createContext(null);

const ThemeProvider = ({ children, initialTheme }) => {
    const [theme, setTheme] = useState(initialTheme);
    const loadTheme = async (themeName) => {
        const response = await fetch(`theming.json`);

        const newTheme = await response.json();
        setTheme(newTheme);
    };

    return (
        <ThemeContext.Provider value={{ theme, loadTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export { ThemeContext, ThemeProvider };